
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch/[slug]",
      function () {
        return require("private-next-pages/launch/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/launch/[slug]"])
      });
    }
  